import React, { useState } from "react";
import { FaCircle, FaPause, FaPlay } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";

function BatchBilling () {

    const [data, setData] = useState([
        {
            folio: 1216598,
            master: "123-44448884",
            house: "S/H",
            fechaHora: "2025-07-15 16:18:49",
            agencia: "DIRECT GLOBALCARGO SA DE CV",
            montoTotal: 614.27,
            estatus: "No respondió Core",
            fileClicked: false,
            isPaused: true
        },
        {
            folio: 1216596,
            master: "123-44448888",
            house: "S/H",
            fechaHora: "2025-05-09 16:43:49",
            agencia: "MONTALVO Y MONTALVO",
            montoTotal: 406,
            estatus: "En batch",
            fileClicked: false,
            isPaused: true
        },
        {
            folio: 1216595,
            master: "123-44448888",
            house: "S/H",
            fechaHora: "2025-05-09 14:31:08",
            agencia: "SONY COMERCIO DE MEXICO SA DE CV",
            montoTotal: 406,
            estatus: "En batch",
            fileClicked: false,
            isPaused: true
        },
        {
            folio: 1216594,
            master: "123-44448888",
            house: "S/H",
            fechaHora: "2025-05-09 14:29:42",
            agencia: "AAACESA ALMACENES FISCALIZADOS SA DE CV A EN P",
            montoTotal: 406,
            estatus: "En batch",
            fileClicked: false,
            isPaused: true
        },
        {
            folio: 1216593,
            master: "123-44448888",
            house: "HBS1, HBS2",
            fechaHora: "2025-05-07 13:44:32",
            agencia: "AAACESA ALMACENES FISCALIZADOS SA DE CV A EN P",
            montoTotal: 614.27,
            estatus: "En batch",
            fileClicked: false,
            isPaused: true
        },
        {
            folio: 1216592,
            master: "123-44448888",
            house: "S/H",
            fechaHora: "2025-05-07 10:45:11",
            agencia: "AAACESA ALMACENES FISCALIZADOS SA DE CV A EN P",
            montoTotal: 406,
            estatus: "En batch",
            fileClicked: false,
            isPaused: true
        }
    ]);

    const handleFileClick = (index) => {
        const updated = [...data];
        updated[index].fileClicked = true;
        setData(updated);
    };

    const togglePausePlay = (index) => {
        const updated = [...data];
        updated[index].isPaused = !updated[index].isPaused;
        setData(updated);
    };

    return(
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <table className="table mt-3">
                            <thead className="text-center">
                                <tr>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}></th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Folio</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Master</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>House</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Fecha y hora</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Agencia/Almacén</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Monto total</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Estatus</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {data.map((item, i) => (
                                    <tr key={i}>
                                        <td><FaCircle style={{ cursor: 'pointer', color: item.fileClicked ? '#00a000 ' : '#d50000 ' }} /></td>
                                        <td>{item.folio}</td>
                                        <td>{item.master}</td>
                                        <td>{item.house}</td>
                                        <td>{item.fechaHora}</td>
                                        <td>{item.agencia}</td>
                                        <td>{item.montoTotal}</td>
                                        <td>{item.estatus}</td>
                                        <td><FiFileText
                                                title="Timbrar"
                                                style={{ color: '#020C41', cursor: 'pointer' }}
                                                onClick={() => handleFileClick(i)}
                                            />
                                            &nbsp;&nbsp;
                                            {item.isPaused ? (
                                                <FaPause
                                                    title="Pausar envío"
                                                    style={{ color: '#020C41', cursor: 'pointer' }}
                                                    onClick={() => togglePausePlay(i)}
                                                />
                                            ) : (
                                                <FaPlay
                                                    title="Reanudar envío"
                                                    style={{ color: '#020C41', cursor: 'pointer' }}
                                                    onClick={() => togglePausePlay(i)}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BatchBilling;